import { cn } from "@omni/utils/styles";
import { Thumbs } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { useImageGalleryContext } from "@/components/ImageGallery/context/imageGallery.context";

type Props = {
    className?: string;
    slideClassName?: string;
};

export const MainSwiper = ({ className, slideClassName }: Props) => {
    const { images, thumbSwiper, setActiveIndex, setMainSwiper } =
        useImageGalleryContext();

    return (
        <Swiper
            className={className}
            modules={[Thumbs]}
            thumbs={{ swiper: thumbSwiper }}
            spaceBetween={10}
            slidesPerView={1}
            centeredSlides={true}
            onActiveIndexChange={(swiper) => {
                setActiveIndex(() => swiper.activeIndex);
            }}
            onSwiper={setMainSwiper}
        >
            {images.map((image, index) => (
                <SwiperSlide key={image.url}>
                    <img
                        className={cn(
                            "tw:w-full tw:object-center tw:object-contain",
                            slideClassName
                        )}
                        src={image.url}
                        alt={image.altText ?? ""}
                        loading={index > 0 ? "lazy" : "eager"}
                        decoding={index > 0 ? "async" : "auto"}
                    />
                </SwiperSlide>
            ))}
        </Swiper>
    );
};
